import { PaymentBreakdownRow } from "./types";
import { formatMoney, formatPercent } from "./helpers";

export function PaymentBreakdown({ rows }: { rows: PaymentBreakdownRow[] }) {
  const total = rows.reduce((acc, r) => acc + r.amount, 0);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-4">
      <h2 className="text-sm font-semibold text-gray-900">Payment breakdown</h2>

      {rows.length === 0 ? (
        <p className="mt-3 text-sm text-gray-400">No transactions recorded.</p>
      ) : (
        <table className="mt-3 min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Method</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Share</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((r) => (
              <tr key={r.label}>
                <td className="px-3 py-2 text-sm font-medium text-gray-900">{r.label}</td>
                <td className="px-3 py-2 text-sm text-right text-gray-900 font-medium">{formatMoney(r.amount)}</td>
                <td className="px-3 py-2 text-sm text-right text-gray-500">{formatPercent(r.share)}</td>
              </tr>
            ))}
            <tr className="bg-gray-50 font-semibold">
              <td className="px-3 py-2 text-sm text-gray-900">Total</td>
              <td className="px-3 py-2 text-sm text-right text-gray-900">{formatMoney(total)}</td>
              <td className="px-3 py-2 text-sm text-right text-gray-900">100%</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
